import { SelectInputProps } from './select-input.props';

export const SelectInputPresets: SelectInputProps = {
  labelProperty: 'name',
  options: [],
  valueProperty: 'id',
};
